module.exports = __webpack_public_path__ + "img/cn_small.ee519a42.png";